import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from '../../../utils/axiosInstance';

const ViewSlots = () => {
  const { scheduleId } = useParams();
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSlots();
  }, [scheduleId]);

  const fetchSlots = async () => {
    try {
      const response = await API.get(`/v1/doctors/schedule/${scheduleId}`);
      setSlots(response.data?.appointmentSlots || []);
    } catch (err) {
      console.error('Failed to load slots:', err);
      setError('Failed to load slots');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h4>Schedule Slots (Schedule ID: {scheduleId})</h4>

      {loading && <p>Loading slots...</p>}
      {error && <p className="text-danger">{error}</p>}

      {!loading && !error && slots.length === 0 && (
        <p>No slots found for this schedule.</p>
      )}

      {!loading && slots.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {slots.map((slot, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{slot.startTime}</td>
                <td>{slot.endTime}</td>
                <td>{slot.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ViewSlots;
